export default "__VITE_ASSET__CP4jOcl5__"